import { ProgressRing } from '@kodprep/platform-ui'
import { TierBadge } from '@/features/Leaderboard/TierBadge'
import type { HomeReadiness, HomeStats, HomeStreak } from '@/lib/api/home'
import { getTierHeadline } from './utils'

interface Props {
  readiness: HomeReadiness
  streak: HomeStreak
  stats: HomeStats
}

export function ProgressHero({ readiness, streak, stats }: Props) {
  const { headline, sub } = getTierHeadline(readiness.tier)
  const isLongestStreak = streak.current > 0 && streak.current >= streak.longest

  return (
    <section className="rounded-xl border border-[#e8e4df] bg-white p-6" aria-label="Progress overview">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-3">
            <TierBadge tier={readiness.tier} />
            <span className="text-xs text-[#9a9589]">Batch rank #{stats.batch_rank}</span>
          </div>
          <h1 className="font-heading text-2xl font-bold text-[#1a1714] leading-tight">{headline}</h1>
          <p className="mt-1 text-sm text-[#9a9589]">{sub}</p>
          {streak.current >= 3 && (
            <div className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-orange-200 bg-orange-50 px-3 py-1 text-xs font-semibold text-[#e8660d]">
              <span aria-hidden="true">🔥</span>
              {streak.current}-day streak
              {isLongestStreak && ' — your longest ever!'}
            </div>
          )}
        </div>
        <div className="flex-shrink-0">
          <ProgressRing value={readiness.score} size={88} />
        </div>
      </div>
    </section>
  )
}
